import { render, staticRenderFns } from "./ImageEditDialog.vue?vue&type=template&id=6454e172&"
import script from "./ImageEditDialog.vue?vue&type=script&lang=js&"
export * from "./ImageEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports